// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".slide-enter[data-v-15511b4f],.slide-leave-active[data-v-15511b4f]{opacity:0;opacity:1;-webkit-transform:translateX(-100%);transform:translateX(-100%)}", ""]);
// Exports
module.exports = exports;
